import { MapPin, Mail, Phone, Clock } from "lucide-react";
import Link from "next/link";
import { GeneralData } from "@/types/components";
import { formatPhoneNumber } from "@/lib/helper";
import SocialMedia from "../Footer/SocialMedia";
import ScrollAnimation from "../ScrollAnimations";

interface ContactInfoProps {
  generalData: GeneralData["content"];
  form: {
    title: string;
    description: string;
  };
}

export default function ContactInfo({ generalData, form }: ContactInfoProps) {
  const { general_info, working_hours_short_version, google_maps } =
    generalData;
  const { phone_number, address, email, social_media } = general_info;

  return (
    <ScrollAnimation className="lg:col-span-2">
      <h2 className="text-3xl font-bold  mb-4 text-[#284D93]">{form.title}</h2>
      <p className="text-[18px] leading-[24px] text-[#4B5563] mb-8">
        {form.description}
      </p>
      <ul
        className="space-y-6 text-[#374151] [&_li]:flex [&_li]:items-start
        [&_svg]:size-6 [&_svg]:flex-shrink-0 [&_svg]:mr-4 [&_svg]:text-[#5378BC] [&_svg]:mt-1
        [&_span]:font-semibold [&_span]:block [&_a]:font-medium [&_a]:hover:text-[#5378BC] [&_a]:transition-colors"
      >
        {address && (
          <li>
            <MapPin />
            <div>
              <span>Our Address</span>
              <Link
                href={google_maps?.link || "#"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {address}
              </Link>
            </div>
          </li>
        )}
        {email && (
          <li>
            <Mail />
            <div>
              <span>Email Us</span>
              <Link target="_blank" href={`mailto:${email}`}>
                {email}
              </Link>
            </div>
          </li>
        )}
        {phone_number && (
          <li>
            <Phone />
            <div>
              <span>Call Us</span>
              <Link href={`tel:${phone_number}`}>
                {formatPhoneNumber(phone_number)}
              </Link>
            </div>
          </li>
        )}
        {working_hours_short_version && (
          <li className=" [&_p]:font-medium ">
            <Clock />
            <div>
              <span>Working Hours</span>
              {working_hours_short_version["Mon - Fri"] && (
                <p>Monday–Friday: {working_hours_short_version["Mon - Fri"]}</p>
              )}
              {working_hours_short_version.Sat && (
                <p>Saturday: {working_hours_short_version.Sat}</p>
              )}
              {working_hours_short_version.Sun && (
                <p>Sunday: {working_hours_short_version.Sun}</p>
              )}
            </div>
          </li>
        )}
      </ul>
      {social_media && (
        <div className="mt-8">
          <h3 className="text-xl font-bold  mb-4 text-[#284D93]">Follow Us</h3>
          <SocialMedia social_media={social_media} />
        </div>
      )}
    </ScrollAnimation>
  );
}
